export const SHOP_CLOSURE_REASONS = [
  'Severe weather conditions',
  'Heavy rain or flooding',
  'Planned maintenance',
  'Emergency repairs',
  'Power outage',
  'Water supply interruption',
  'Gas supply interruption',
  'Equipment failure',
  'Internet or system outage',
  'Staff shortage',
  'Staff training',
  'Health and safety precaution',
  'Sanitation or deep cleaning',
  'Ingredient or stock shortage',
  'Sold out for the day',
  'Public holiday',
  'Festival or religious observance',
  'Private event or full venue booking',
  'Renovation work',
  'Government or local authority restriction',
  'Local transport or access disruption',
  'Unexpected emergency',
  'Temporary operational break',
  'Other reason'
];

export const SHOP_OPENING_REASONS = [
  'Regular operations started',
  'Regular operations resumed',
  'Maintenance completed',
  'Service disruption resolved',
  'Special opening',
  'Extended service hours',
  'Festival or event opening',
  'Open due to customer demand',
  'Other reason'
];

export const OTHER_STATUS_REASON = 'Other reason';

export const getStatusReasons = (isOpen) => (isOpen ? SHOP_OPENING_REASONS : SHOP_CLOSURE_REASONS);

export const resolveStatusReason = (selectedReason, otherReason) =>
  selectedReason === OTHER_STATUS_REASON ? String(otherReason || '').trim() : String(selectedReason || '').trim();

export const matchStatusReason = (reason, isOpen) => {
  const normalized = String(reason || '').trim();
  const reasons = getStatusReasons(isOpen);
  return reasons.includes(normalized)
    ? { selectedReason: normalized, otherReason: '' }
    : { selectedReason: OTHER_STATUS_REASON, otherReason: normalized };
};
